import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import CssBaseline from '@material-ui/core/CssBaseline';
import 'react-toastify/dist/ReactToastify.css';
import store from './data/store';
import 'react-sortable-tree/style.css';
import './theme/fonts.css';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { ThemeModeProvider } from './theme/ThemeModeProvider';

ReactDOM.render(
  <Provider store={store}>
    <ThemeModeProvider>
      <>
        <CssBaseline />
        <App />
      </>
    </ThemeModeProvider>
  </Provider>,
  document.getElementById('root'),
);

// This app ships no real service-worker.js (production registration was
// blindly targeting a file that doesn't exist, failing with a MIME-type
// SecurityError on every load) — and worse, anyone who *did* get a service
// worker installed from an old build before that broke would be stuck with
// it forever, since a failed re-registration attempt never unregisters an
// already-active one. unregister() actively removes any such leftover
// worker so it stops intercepting requests/serving stale cached content.
serviceWorker.unregister();
